import { useCallback, useEffect, useState } from 'react';
import { usePrivilege } from '../../components/priviledge/PriviledgeProvider';
import { HeadquarterService } from '../../services/headquarters/headquarterService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage unlinked headquarters fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de sedes no vinculadas.
----------------------------------------------------------------------------------------*/

const useUnlinkedHeadquarters = () => {

    const { userCan } = usePrivilege();
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const fetchUnlinkedHeadquarters = useCallback(async () => {
        try {
            if (!userCan('list', 'headquarter')) return;
            
            setLoading(true);
            const service = new HeadquarterService();
            const response = await service.listUnlinked({ limit: 999999 });
            const fetchedData = response.getResponseData();

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching unlinked headquarters:', error);
        } finally {
            setLoading(false);
        }
    }, [userCan]);

    useEffect(() => {
        fetchUnlinkedHeadquarters();
    }, [fetchUnlinkedHeadquarters]);

    const getUnlinkedHeadquartersList = () => {
        return data;
    };

    return { 
        unlinkedHeadquarters: data,
        loading,
        fetchUnlinkedHeadquarters, 
        getUnlinkedHeadquartersList 
    };    
}

export default useUnlinkedHeadquarters;